import { exportClassificationsToSheet } from "@/api/downloadObligationsToSheet";
import { getUrlsDownloadFile } from "@/api/uploadFiles";
import { notificate } from "@/utils/message";

// Genera el Excel de clasificaciones, obtiene su enlace de Drive y lo abre.
// Side-effects (notificate/window.open) incluidos; el caller maneja su propio
// estado de loading. Devuelve la promesa de la cadena.
export function downloadClassificationFile({ rutCompany, driveId, fileName }) {
    notificate(
        `<strong>Procesando!</strong><br>
        Generando archivo de clasificaciones...`,
        "is-info is-light"
    );

    return exportClassificationsToSheet({ rut_company: rutCompany })
        .then(() => {
            notificate(
                `<strong>Éxito!</strong><br>
                Archivo generado. Obteniendo enlace de descarga...`,
                "is-success is-light"
            );
            return getUrlsDownloadFile({ drive_id: driveId, file_name: fileName });
        })
        .then(({ data }) => {
            notificate(
                `<strong>Éxito!</strong><br>
                Descarga iniciada.`,
                "is-success is-light"
            );
            let url = data.url_download;
            url = url.match(/^https?:/) ? url : "//" + url;
            window.open(url);
        })
        .catch((error) => {
            notificate(
                `<strong>Error!</strong><br>
                Ocurrió un error en la descarga del archivo.`,
                "is-danger is-light"
            );
            console.error("Error downloading file:", error);
        });
}
